module.exports = "<option value={{value}} ng-transclude></option> ";